import * as React from 'react'

import { Table } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type Dashboard from 'modules/reports/store/models/Dashboard'

import Item from './_Item'

interface Props {
  dashboards: Dashboard[]
}

const Body = ({ dashboards }: Props) => {
  if (dashboards.length === 0) {
    return (
      <Table.Body>
        <Table.Blank colSpan={5} text={i18n.t('custom_reports.dashboards.no_results')} />
      </Table.Body>
    )
  }

  return (
    <Table.Body>
      {dashboards.map((dashboard) => (
        <Item key={dashboard.id} dashboard={dashboard} />
      ))}
    </Table.Body>
  )
}

export default observer(Body)
